import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import IframeResizer from "iframe-resizer-react";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    source = "source",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.source]: string;
    };
}

export interface VideoFrameStyles {
    iframe?: InjectableCss;
}

export const videoFrameStyles: VideoFrameStyles = {
    iframe: {
        css: css`
            margin: auto;
            aspect-ratio: 16/9;
            width: 100%;
        `,
    },
};

const validateVideoUrl = (video: string) => {
    const youTube = ["https://www.youtube.com/", "https://youtu.be/"];
    const vimeo = "https://vimeo.com/";
    const vimeoEmbed = "https://player.vimeo.com/video/";

    if (video.startsWith(youTube[0])) {
        return video.includes(`${youTube[0]}watch?v=`)
            ? `${youTube[0]}embed/${video.replace(`${youTube[0]}watch?v=`, "")}`
            : video;
    }
    if (video.startsWith(youTube[1])) {
        return video.replace(youTube[1], `${youTube[0]}embed/`);
    }
    if (video.startsWith(vimeo)) {
        return video.replace(vimeo, vimeoEmbed);
    }
};

const styles = videoFrameStyles;

export const VideoFrame: FC<OwnProps> = ({ fields }) => {
    const video = validateVideoUrl(fields.source);

    if (!video) {
        return null;
    }

    return (
        <StyledWrapper {...styles.iframe}>
            <IframeResizer style={{ width: "100%", height: "100%", border: 0 }} src={video} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: VideoFrame,
    definition: {
        group: "Basic",
        icon: "link-simple",
        fieldDefinitions: [
            {
                displayName: "Video Url (youtube, vimeo)",
                name: fields.source,
                fieldType: "Contextual",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
